// #48 sneak legibility (S6, pt6: "no noise or awareness indicator ... getting past them was a footrace"). Over the turned
// only: a red outlined '!' over one that is after you, a red outlined '?' over one walking to a noise it heard and after
// nobody, nothing over one that has not noticed anything. Smaller than an NPC's gold quest tag (11 x 13, filled) and a
// different shape (an outline, no fill), and never the orange 'hidden behind something' rim. The server appends the two
// id lists to every snapshot, per viewer (main.ts S2C.Snap).
import { Container, Sprite, Texture } from 'pixi.js';
import { Kind } from '../../shared/src/protocol';

const RED = '#e2402a', INK = '#0f0e22';
function glyph(ch: '!' | '?'): Texture {
  // 7 x 11: a red outline box, the mark in red, an ink keyline round the outside so it reads on snow and on brick
  const c = document.createElement('canvas'); c.width = 9; c.height = 13; const g = c.getContext('2d')!;
  g.fillStyle = INK; g.fillRect(0, 0, 9, 13); g.clearRect(2, 2, 5, 9);
  g.fillStyle = RED; g.fillRect(1, 1, 7, 1); g.fillRect(1, 11, 7, 1); g.fillRect(1, 1, 1, 11); g.fillRect(7, 1, 1, 11);
  if (ch === '!') { g.fillRect(4, 3, 1, 4); g.fillRect(4, 8, 1, 1); }
  else { g.fillRect(3, 3, 3, 1); g.fillRect(5, 4, 1, 2); g.fillRect(4, 5, 1, 2); g.fillRect(4, 8, 1, 1); }
  return Texture.from(c);
}

export class FoeMarks {
  root = new Container();
  aware = new Set<number>();
  heard = new Set<number>();
  private tags = new Map<number, Sprite>();
  private tex: Partial<Record<'!' | '?', Texture>> = {};

  /** the two lists appended to S2C.Snap */
  read(aware: number[], heard: number[]) { this.aware = new Set(aware); this.heard = new Set(heard); }

  /** every frame, after the views moved */
  update(views: Map<number, { e: { kind: number; flags: number }; spr: Container }>) {
    for (const [id, s] of this.tags) {
      const v = views.get(id), k = this.aware.has(id) ? '!' : this.heard.has(id) ? '?' : '';
      if (!v || !k || !v.spr.visible || (v.e.flags & 8)) { s.destroy(); this.tags.delete(id); }
    }
    for (const id of [...this.aware, ...this.heard]) {
      const v = views.get(id); if (!v || !v.spr.visible || (v.e.kind !== Kind.Zombie && v.e.kind !== Kind.Boss) || (v.e.flags & 8)) continue;
      const k: '!' | '?' = this.aware.has(id) ? '!' : '?';
      let s = this.tags.get(id);
      if (s && (s as any).k !== k) { s.destroy(); this.tags.delete(id); s = undefined; }
      if (!s) { s = new Sprite(this.tex[k] ??= glyph(k)); s.anchor.set(0.5, 1); (s as any).k = k; this.root.addChild(s); this.tags.set(id, s); }
      s.x = Math.round(v.spr.x); s.y = Math.round(v.spr.y - 44 - 4);   // (over the head, as the quest tags, a little lower: smaller)
    }
  }
  /** for the checks: id -> '!' | '?' drawn now */
  drawn(): Record<number, string> { const o: Record<number, string> = {}; for (const [id, s] of this.tags) if (s.visible) o[id] = (s as any).k; return o; }
}
